<template>
  <DefaultLayout :pageProps="pageProps">
    <template #content>
      <div
        v-if="!isWebApp"
        style="display: flex; flex-direction: column; gap: 20px"
      >
        <b-spinner variant="primary" v-if="loading" />
        <SubmitButton
          v-else
          class="mt-5"
          :text="submitButtonText"
          @click.native="backToTheApp"
        />
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import SubmitButton from "@/components/buttons/SubmitButton";
import { logging } from "@/api/logs";
import { mix_panel } from "@/services/common/mixpanel";
import OriginEnum from "@/helpers/enums/OriginEnum";
import DeeplinkEnum from "@/helpers/enums/DeeplinkEnum";
import { token } from "@/api/token";
import redirect, {
  getExtraOathParams,
  isOauthForSI,
  isOauthForSIorEnableSync,
} from "../../mixins/helpers/redirect";
import AuthType from "../../helpers/enums/AuthType";
import DefaultLayout from "../../layout/DefaultLayout.vue";
import { CUSTOMER as customer, CUSTOMER } from "../../environment/env.customer";

export default {
  name: "index",
  components: {
    DefaultLayout,
    SubmitButton,
  },
  mixins: [redirect],
  data() {
    return {
      loading: true,
      isWebApp: false,
      oauthError: false,
      isOauthForSIorEnableSync: false,
      isOauthForSI: false,
      submitButtonText: " Go to the app",
      customer: CUSTOMER,
    };
  },
  computed: {
    pageProps() {
      if (this.isWebApp) {
        return { title: `Redirecting you to ${customer.name}...` };
      }

      if (this.oauthError) {
        return {
          title: "Oops!",
          description: "Permission was denied. Please try again.",
        };
      }

      if (this.isOauthForSIorEnableSync) {
        if (this.isOauthForSI) {
          return {
            title: "One last step",
            description:
              "Click on the button below to finish connecting your shared inbox",
          };
        }
        return {
          title: "One last step",
          description:
            "Click on the button below to finish connecting your personal inbox",
        };
      }

      if (!this.$route.query.login) {
        return {
          title: "Congratulations!",
          description:
            "Your account has been successfully created. Click below to get started.",
        };
      }

      return {
        title: "Welcome back!",
        description:
          "    We have identified that you are an existing Loop user. Use the button below to log back into Loop.",
      };
    },
  },
  async mounted() {
    this.loading = true;
    this.oauthError = !!localStorage.oauthError;
    this.isOauthForSIorEnableSync = isOauthForSIorEnableSync();
    this.isOauthForSI = isOauthForSI();

    if (this.isOauthForSIorEnableSync) {
      this.submitButtonText = this.isOauthForSI
        ? "Connect shared inbox"
        : "Connect personal inbox";
    }

    delete localStorage.oauthError;

    if (
      this.$store.state.data.origin.includes("web") ||
      this.$store.state.data.origin.includes("marketing")
    ) {
      this.isWebApp = true;
    }

    try {
      if (this.$route.query.code !== undefined) {
        this.code = this.$route.query.code;
      } else if (!this.oauthError) {
        let response = await token.getCode();
        this.code = response.data.code;
      }

      if (this.isOauthForSIorEnableSync) {
        this.redirectToApp();
      } else if (this.$route.query.signup_complete) {
        await mix_panel.onBasicEvent(
          "Signup completed",
          "true",
          {},
          this.redirectToApp
        );
      } else {
        await mix_panel.onBasicEvent(
          "Login completed",
          "true",
          {},
          this.redirectToApp
        );
      }
    } catch (e) {
      this.$router.push(`/?from=${this.$store.state.data.origin}`);
    }
    this.loading = false;
  },
  methods: {
    redirectToApp() {
      if (this.isWebApp) {
        this.redirectToWeb(
          this.code,
          this.$route.query.code !== undefined
            ? AuthType.AuthPassword
            : AuthType.AuthCode,
          this.$store.state.auth.email,
          this.oauthError
        );
      }
    },
    async backToTheApp() {
      logging.sendLog(
        `Back to the app clicked ${this.$store.state.auth.strategy}`,
        3
      );
      await mix_panel.onBasicEvent(
        "BackToAppClicked",
        this.$store.state.auth.strategy
      );

      this.processStrategy(this.$store.state.auth.strategy === "loopLogin");
    },
    processStrategy(isLoopLogin) {
      switch (this.$store.state.data.origin) {
        case OriginEnum.DTA:
          isLoopLogin
            ? (window.location = "intheloop://close-web-onboarding")
            : (window.location = `intheloop://code-login?code=${
                this.code
              }${getExtraOathParams(
                this.$store.state.auth.email,
                this.oauthError
              )}`);
          break;
        case OriginEnum.MOBILE:
          isLoopLogin
            ? (window.location = "intheloop://close-web-onboarding")
            : (window.location = `intheloop://code-login?code=${this.code}&email-type=${this.$store.state.data.emailAuthType}`);
          break;
        case OriginEnum.MOBILE_V2:
          isLoopLogin
            ? (window.location = "intheloop://close-web-signin")
            : (window.location = `intheloop://code-login?code=${this.code}&email-type=${this.$store.state.data.emailAuthType}`);
          break;
        case OriginEnum.INVITE:
          isLoopLogin
            ? (window.location = "intheloop://close-web-onboarding")
            : (window.location = `intheloop://code-login?code=${this.code}&email-type=${this.$store.state.data.emailAuthType}&web-app-deeplink=${DeeplinkEnum.CODE_LOGIN}`);
          break;
      }
    },
  },
};
</script>
